import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M18.152 9.206c.115-2.39 0-6.519-1.818-6.366-1.76.153-1.913 8.144-1.913 8.144"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M18.075 9.627c.173-1.3.613-3.27 1.76-3.365 1.703-.134 1.225 5.62.536 9.234-.67 3.594-1.871 6.504-4.878 5.945C12.486 20.88 10.366 18.32 13 17c3-1.505 3.8 4.452-3.5 3.5M11.705 10.468s.498-7.274-1.798-6.997c-2.18.264-1.492 4.869-1.3 7.048.19 2.18-.517 3.116-1.512 3.288s-4.209-.917-4.324 1.568c-.114 2.485 3.578 2.393 5.357 2.523"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M11.664 7.237s-.629-5.352 1.418-5.39c2.047-.039 1.645 4.931 1.645 4.931"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M20.371 15.496c-.67 3.593-1.871 6.504-4.878 5.945C12.486 20.88 10.366 18.32 13 17c3-1.505 3.8 4.452-3.5 3.5"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const HandStopIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
